
export const GET_ALL_PRODUCTS = "GET_ALL_PRODUCTS"
export const GET_EXAM_SCHEDULE = "GET_EXAM_SCHEDULE"
export const GET_TOTAL_BUSINESS = "GET_TOTAL_BUSINESS"
export const GET_CHART_PRODUCT_WISE = "GET_CHART_PRODUCT_WISE"
export const GET_POLCIY_PRODUCT_WISE = "GET_POLCIY_PRODUCT_WISE"
export const GET_POLCIY_INSURER_WISE = "GET_POLCIY_INSURER_WISE"
